import { graphql } from "gatsby";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import MoreInformation from "../components/Trips/MoreInformation";
import { presentationTrips } from "../components/Trips/trips-data";

const tripInformation = presentationTrips.find((x) => x.id === "sant-vicenc-trip");

const Cala = () => {
  const { t } = useTranslation();

  return (
    <MoreInformation
      title={t("title")}
      description={t("description")}
      tripInformation={tripInformation!}
      timeTable={
        <>
          <Trans i18nKey={tripInformation!.moreInformation.timetable}>
            <ul>
              <li>Item 1</li>
              <li>Item 2</li>
            </ul>
          </Trans>
        </>
      }
    />
  );
};

export default Cala;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["translation", "cala"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
